import { gql } from '@apollo/client';

export const LABEL_BASE_FRAGMENT = gql`
    fragment LabelBaseFragment on Label {
        guid
        name
        slug
        isExclusive
    }
`;

export const LABEL_EXCERPT_FRAGMENT = gql`
    fragment LabelExcerptFragment on Label {
        ...LabelBaseFragment
        artworkUrl
    }
    ${LABEL_BASE_FRAGMENT}
`;

export const LABEL_DETAIL_FRAGMENT = gql`
    fragment LabelDetailFragment on Label {
        ...LabelExcerptFragment
        name
        description
        artworkUrl
        coverUrl
        isExclusive
        sampleCount
        packCount
    }
    ${LABEL_EXCERPT_FRAGMENT}
`;
